import { render, staticRenderFns } from "./LeccionF2.vue?vue&type=template&id=8e8b08ac&"
import script from "./LeccionF2.vue?vue&type=script&lang=js&"
export * from "./LeccionF2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports